<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data, $index) in langData"
          :key="$index"
          :class="{ active: $index == 0 }"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true ? 'tab' + $index : ''"
            data-toggle="tab"
            :href="true ? '#tab-' + $index : ''"
            aria-expanded="true"
            @click="showTab($event, $index)"
            >{{ $t("message." + data) }}</a
          >
        </li>
      </ul>
    </div>
    <div class="form-horizontal detailPage">
      <div class="tab-content">
        <div
          :id="'tab-' + index"
          v-for="(langItem, index) in hotTagList"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Select Hot Tags </label>
                <div class="col-sm-4">
                  <el-select v-model="langItem.hotType">
                    <el-option
                      v-for="item in hotTypeObj"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group" v-if="langItem.hotType === '1'">
                <label class="col-sm-2 control-label"> Tag List </label>

                <div class="col-sm-10">
                  <el-table
                    :data="hotTagCtrList"
                    style="width: 100%"
                    border
                    ref="multipleTable"
                  >
                    <el-table-column
                      prop="order"
                      label="Order"
                      width="200"
                    ></el-table-column>
                    <el-table-column
                      prop="name"
                      label="Name"
                      width="200"
                    ></el-table-column>
                    <el-table-column
                      prop="synonyms"
                      label="Synonyms"
                      width="200"
                    ></el-table-column>
                    <el-table-column
                      prop="ctr"
                      label="Ctr"
                      width="200"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="form-group" v-if="langItem.hotType === '2'">
                <label class="col-sm-2 control-label"> Tag List </label>
                <div class="col-sm-10">
                  <el-transfer
                    filterable
                    target-order="push"
                    v-model="langItem.tagIds"
                    :titles="['All Tags', 'Display as Hot Tags']"
                    :data="tagsList"
                  ></el-transfer>
                </div>
              </div>
              <div class="form-group" v-if="langItem.hotType == '2'">
                <label class="col-sm-2 control-label"> Most Viewed Tags </label>
                <div class="col-sm-10">
                  <el-table
                    :data="hotTagCtrList20"
                    style="width: 100%"
                    border
                    ref="multipleTable"
                  >
                    <el-table-column
                      prop="order"
                      label="Order"
                      width="200"
                    ></el-table-column>
                    <el-table-column
                      prop="name"
                      label="Name"
                      width="200"
                    ></el-table-column>
                    <el-table-column
                      prop="synonyms"
                      label="Synonyms"
                      width="200"
                    ></el-table-column>
                    <el-table-column
                      prop="ctr"
                      label="Ctr"
                      width="200"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div
                      class="btn btn-primary"
                      v-if="checkPermission('HOT_TAG_LIST_SAVE')"
                      @click="submit()"
                    >
                      {{ $t("message.Save") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

let hotTypeObj = [
  {
    value: "1",
    label: "By number of views",
  },
  {
    value: "2",
    label: "Pick from a list ",
  },
];

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      hotTypeObj: hotTypeObj,
      total: 10,
      hotTagCtrList: [],
      hotTagCtrList20: [],
      tagsList: [],
      hotTagList: [
        {
          langCode: "en_US",
          tagIds: [],
          hotType: hotTypeObj[0].value,
        },
        {
          langCode: "zh_HK",
          tagIds: [],
          hotType: hotTypeObj[0].value,
        },
        {
          langCode: "zh_CN",
          tagIds: [],
          hotType: hotTypeObj[0].value,
        },
      ],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
    this.getHotTagCtrList(this.hotTagList[0].langCode);
    this.getHotTagCtrList20(this.hotTagList[0].langCode);
    this.getHotTagList();
    this.getTagList(this.hotTagList[0].langCode);
  },
  methods: {
    async init() {},
    async getHotTagCtrList(langCode) {
      let obj = this.getAuthObj();
      obj.langCode = langCode;
      obj.total = this.total;
      obj.apiUrl = "/getHotTagCtrList";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      this.$set(this, "hotTagCtrList", data.data.resultList);
    },
    async getHotTagList() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/getHotTagList";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      if (data.data.resultList.length > 0) {
        for (var i = 0; i < data.data.resultList.length; i++) {
          data.data.resultList[i].hotType = data.data.resultList[
            i
          ].hotType.toString();
        }
      }
      this.$set(this, "hotTagList", data.data.resultList);
    },
    async getHotTagCtrList20(langCode) {
      let obj = this.getAuthObj();
      obj.langCode = langCode;
      obj.total = 20;
      obj.apiUrl = "/getHotTagCtrList";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      this.$set(this, "hotTagCtrList20", data.data.resultList);
    },
    async getTagList(langCode) {
      let obj = this.getAuthObj();
      obj.sortField = "id";
      obj.sortType = "ASC";
      obj.startRow = 0;
      obj.maxRows = 1000000;
      obj.status = 1;
      obj.isUse = true;
      obj.langCode = langCode;
      obj.apiUrl = "/getTagList";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      this.tagsList = [];
      for (var i = 0; i < data.data.resultList.length; i++) {
        this.tagsList.push({
          key: data.data.resultList[i].id,
          label: data.data.resultList[i].name,
        });
      }
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        var langData = [];
        for (var i = 0; i < this.hotTagList.length; i++) {
          langData.push({
            langCode: this.hotTagList[i].langCode,
            tagIds: this.hotTagList[i].tagIds,
            hotType: this.hotTagList[i].hotType,
          });
        }
        obj.langData = JSON.stringify(langData);
        obj.apiUrl = "/saveHotTag";
        let data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        if (data.data.errorCode === 0) {
          this.$toastr.s("Success");
          this.getHotTagList();
        }
      } catch (err) {}
    },
    changeTab: function (id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
      this.getHotTagCtrList(this.hotTagList[id].langCode);
      this.getHotTagCtrList20(this.hotTagList[id].langCode);
      this.getTagList(this.hotTagList[id].langCode);
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  },
};
</script>
